<template>
  <div class="index">
    <div class="left">
      <div class="content" id="preview">
        <div class="image" :style="{width: previewImageData.width + 'px', height: previewImageData.height + 'px'}">
          <img :src="pageOCRData.userAnswer">
          <!--div v-for="(item, index) in pointList" :key="index" 
                :class='["point",questionsEditedMap[item.questionCode]?"pointEdited":"",item.questionCode == selectedQuestionKey?"pointSelectedActive":""]'
                :style="{top: item.actualTop + 'px', left: item.actualLeft + 'px'}" 
                @click="click_question(item.questionCode)">✍</div-->
          <div v-for="(item, index) in pointList" :key="'point' + index" 
                  :class='["queBox",questionsEditedMap[item.questionCode]?"queBoxEdited":"",item.questionCode == selectedQuestionKey?"queBoxSelectedActive":""]'
                  :style="{width: item.boxWidth + 'px', height: item.boxHeight + 'px', left: item.x1 + 'px', top: item.y1 + 'px'}"
                @click="click_question(item.questionCode)">
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="nav">
          <div class="bookList">
            <label class="text">切换教辅</label>
              <el-select style="width:315px;" v-model="bookName" placeholder="请选择" @change="click_book_change">
                <el-option v-for="(book,bookindex) in books"
                          :key="book.anBookId"
                          :label="book.bookNameShow"
                          :value="bookindex">
                </el-option>
              </el-select>
          </div>
          <!--div class="btn" @click="click_flag_page_status(1)">标记本页已编辑</div-->
        </div>
        <div class="pagePanel">
          <div class="pageList">
            <div  v-for="(page,index) in pages" :key="index" 
                  :class='["page",page.pageSeq == selectedPageKey ? "pageSelectedActive":""]'
                  @click="click_book_page(page.pageSeq)" >
                  {{page.pageSeq}}页
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="content">
        <div>以下是（第{{selectedPage.pageSeq}}页）相关的题目资源素材：</div>
        <div class="imageList">
          <div class="listItem" v-for="(question, index) in questionDatas " :key="index">
            <div class="imgBox">
              <img :src="question.subjectUrl"/>
            </div>
            <div class="btns">
              <div :class='[question.videoUrl==""?"videoStateNo":"videoStateYes"]'>★</div>
              <div class="btn" >预览</div>
              <div class="btn" @click="click_question_detail_bind_append(question)">绑定</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="tips">
          <div class="text_tip_main">当前选中题目的设置详情</div> <div class="btn" @click="resetQuestionStatus"  >重置</div>
        </div>
        <div class="infos">
            <div class="info">
              <label class="text_tip_sub">题目解析：</label>
              <div class="text_val_setting">
                <input class="input" v-model="analysisUrl" disabled />
              </div>
            </div>
            <div class="info">
              <label class="text_tip_sub">解析视频：</label>
              <div class="text_val_setting">
                <input class="input" v-model="videoUrl" disabled />
              </div>
            </div>
            <div class="info">
              <label class="text_tip_sub">视频封面：</label>
              <div class="text_val_setting">
                <input class="input" v-model="videoFm" disabled />
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {load_books,unbind_video,load_datas_pages,load_page_ocr_detail,load_page_video_done,load_page_videos,bind_video,page_status_flag } from '@/api/edas'
import {MessageBox,Message } from 'element-ui';

export default {
  name: 'App',
  data(){
    return {
      books : [],
      selectedBook : {},
      bookName : '未选择',
      pages : [],
      selectedPage : {},
      questionDatas: [],
      questionsEditedMap : {},
      pageOCRData: {},                              //  初始数据
      previewImageData: {},           //  计算后的图片对象
      pointList: [],                  //  计算后的图标位置信息
      selectedPageKey : '',   //处理选中状态的
      selectedQuestionKey : '',

      //题目详细展示栏目
      analysisUrl:'未设置',
      videoUrl:"未设置",
      videoFm:"未设置"

    }
  },
  mounted: function() {

    load_books().then(res=>{
        console.log(res);
        this.books = res.data;
        this.selectedBook = this.books[0];
        console.log(" set book ",this.books);
    }).catch(err=>{
        console.log(err);
    })
    
   // this.getImageScaleSize(this.imageData);


  },

  watch :{
       "selectedBook" : function(last,old){
          console.log("watch  selectedBook",JSON.stringify(last));
          this.bookName = last.bookNameShow;
          this.reset_page_content_when_change();
          load_datas_pages(last.anBookId).then(res=>{
              //console.log('load_datas_pages' , res);
              this.pages = res.data;
              if(this.pages.length > 0){
                this.selectedPage = this.pages[0];
                this.selectedPageKey = this.selectedPage.pageSeq;
              }
          })
       },
       "selectedPage" : function(last,old){
          //console.log('new selectedPage ',last);
          if(last && last.pageSeq){
            load_page_ocr_detail(this.selectedBook.anBookId,last.pageSeq).then(resp=>{
                //console.log(resp);
                this.pageOCRData = resp.data;
                //展现当前页面的题目分析结果
                this.getImageScaleSize(this.pageOCRData);
            });
            //加载当前页可以选择的小睿素材
            load_page_videos(this.selectedBook.xrBookId,last.pageSeq,0).then(resp=>{
                console.log("load_page_videos" , resp);
                this.questionDatas = resp.data;
            });

            //查找已经关联的记录痕迹
            load_page_video_done(this.selectedBook.anBookId,last.pageSeq).then(resp =>{
                //console.log("load_page_video_done",resp.data);
                this.questionsEditedMap = resp.data;
            });
          }else{
            console.log('no have page info ');
            this.reset_page_content_when_change();
          }
       }
  },

  methods: {

    reset_page_content_when_change:function(){
        //重置该值
        this.selectedPage = '';
        this.selectedPageKey = '';
        this.pageOCRData = {};
        this.selectedQuestionKey = '';
        this.pages = [];
        this.questionsEditedMap = {};
        this.pointList = [];
        this.questionDatas = [];
        this.analysisUrl = '';
        this.videoUrl = '';
        this.videoFm = '';
    },

    getImageScaleSize: function (imageData) {
			let imageSizeInfo = {
				width: 0,
				height: 0
			};

			//原始宽高
			const originalWidth = imageData.imageWidth;
			const originalHeight = imageData.imageHeight;
			const originalScale = originalHeight / originalWidth;

			imageSizeInfo.originalWidth = originalWidth;
			imageSizeInfo.originalHeight = originalHeight;

			//容器宽高
			const systemInfo = document.getElementById('preview');;
			const windowWidth = systemInfo.offsetWidth;
			const windowHeight = systemInfo.offsetHeight;
      console.log('容器宽高', windowWidth, windowHeight);
			const windowscale = windowHeight / windowWidth;
      
			if (originalScale <= windowscale) {
				//图片高宽比小于等于屏幕高宽比
				//图片缩放后的宽为屏幕宽
				imageSizeInfo.width = windowWidth;
				imageSizeInfo.height = (windowWidth * originalHeight) / originalWidth;
			} else {
				//图片高宽比大于屏幕高宽比
				//图片缩放后的高为屏幕高
				imageSizeInfo.height = windowHeight;
				imageSizeInfo.width = (windowHeight * originalWidth) / originalHeight;
			}
			console.log('缩放后的宽: ' + imageSizeInfo.width + '缩放后的高: ' + imageSizeInfo.height + '，windowscale: ' + windowscale);
			this.previewImageData = imageSizeInfo;

      const widthScal = imageSizeInfo.width / originalWidth;
      const heightScal = imageSizeInfo.height / originalHeight;
      let pointList = JSON.parse(JSON.stringify(imageData.questions));
      console.log(imageData);
      pointList.forEach(que => {
        que.x1 = (que.regionArea.x1 * widthScal).toFixed(2);
        que.y1 = (que.regionArea.y1 * heightScal).toFixed(2);
        que.boxWidth = ((que.regionArea.x2 - que.regionArea.x1) * widthScal).toFixed(2);
        que.boxHeight = ((que.regionArea.y2 - que.regionArea.y1) * heightScal).toFixed(2);
        que.actualTop = (que.showPos.y * heightScal).toFixed(2);
        que.actualLeft = (que.showPos.x * widthScal).toFixed(2);
      });
      console.log(pointList);
      this.pointList = pointList;
		},

    
    click_question: function(newQuestionCode) {
      //选中某道题目
      this.selectedQuestionKey = newQuestionCode;
      //console.log('newQuestionCode',newQuestionCode);
      if(this.questionsEditedMap[newQuestionCode]){
          this.analysisUrl = this.questionsEditedMap[newQuestionCode].analysisUrl;
          this.videoUrl = this.questionsEditedMap[newQuestionCode].video;
          this.videoFm = this.questionsEditedMap[newQuestionCode].videoFm;
      }else{
        this.analysisUrl = "未设置";
        this.videoUrl = "未设置";
        this.videoFm = "未设置";
      }

    },
    

    
    click_book_change:function(bookindex){
      //切换或选择某本书
      console.log('click_book_change',bookindex);
      this.selectedBook = this.books[bookindex];
    },


    click_book_page : function(newPageSeq){
      //选中某个教辅的页面
      console.log('click_book_page',newPageSeq);
      if(this.pages){
        this.pages.forEach((page)=>{
          //console.log('page',page);
          if(page.pageSeq == newPageSeq){
            this.selectedPage = page;
            this.selectedPageKey = page.pageSeq;
            this.selectedQuestionKey = '';
            console.log('chose page',page);
          }
        })
      }
    },


    click_flag_page_status : function(newStatus){
        //标记该页面对应的处理状态
        const anBookId = this.selectedBook.anBookId;
        const pageCode = this.selectedPageKey;
        page_status_flag(anBookId,pageCode,newStatus).then(resp =>{
            if(resp.code ==='001'){
                alert('设置成功')
            }else{
              alert("设置失败")
            }
        });

    },


    click_question_detail_bind_append : function(question){
        //设置关键
        console.log('click_question_detail_bind_append',JSON.stringify(question));
        console.log("selectedBook",this.selectedBook);
        const videoUrl = question.videoUrl;
        const videoName = question.videoName;
        const videoFm = question.videoFm;
        const analysisUrl = question.analysisUrl;
        const anBookId = this.selectedBook.anBookId;
        const pageCode = this.selectedPageKey;
        const questionCode = this.selectedQuestionKey;
        const term = this.selectedBook.term;
        const subject = this.selectedBook.subject;
        const _grade = this.pageOCRData.grade;
        bind_video(anBookId,pageCode,_grade,term,subject,questionCode,videoUrl,videoName,videoFm,analysisUrl).then(resp=>{
            //绑定成功后，要同步到本地的记录上
            if(resp.code == '001'){

              Message({
                    message: '操作成功' || resp.resultMsg,
                    type: 'tip',
                    duration: 3 * 1000
              });

              let newSetting  = {
                 analysisUrl : analysisUrl,
                 video : videoUrl,
                 videoFm : videoFm,
                 videoName : videoName
              }
              this.questionsEditedMap[questionCode] = newSetting;
              this.analysisUrl = analysisUrl;
              this.videoUrl = videoUrl;
              this.videoFm = videoFm;
            }else{
              
              Message({
                    message: '操作失败' ,
                    type: 'error',
                    duration: 3 * 1000
              });
            }
        });
    },

    //重新设置题目的状态
    resetQuestionStatus:function(){
        const anBookId = this.selectedBook.anBookId;
        const pageCode = this.selectedPageKey;
        const questionCode = this.selectedQuestionKey;
        unbind_video(anBookId,pageCode,questionCode).then(resp =>{
            console.log('resetQuestionStatus',resp);
            delete this.questionsEditedMap[questionCode];
            if(resp.code =='001'){
              Message({
                    message: '重置成功' || resp.resultMsg,
                    type: 'tip',
                    duration: 3 * 1000
              });
            }else{
                Message({
                    message: '重置失败' || resp.resultMsg,
                    type: 'tip',
                    duration: 3 * 1000
              });
            }
        });
    }



  }
}
</script>

<style lang="less">
  .index{
    width: 100vw;
    height: 100vh;
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    .text_tip_main{
      color: blue;
      font-size: 16px;
      font-weight: 500;
    }
    img{
      width: 100%;
      height: 100%;
    }
    .left, .right{
      width: 50%;
      border: 2px solid #000000;
      display: flex;
      flex-direction: column;
      #preview{
        display: flex;
        justify-content: center;
        .image{
          position: relative;
          .queBox{
            position: absolute;
            cursor: pointer;
            border: 1px solid #b30a18;
          }
          .queBoxSelectedActive{
            color :#152bec;
            border: 2px solid #152bec;
          }
          .queBoxEdited{
            color:chartreuse;
            border: 1px solid chartreuse;
          }
          .point{
            position: absolute;
            cursor: pointer;
            color: #f72727f6;
          }
          .pointSelectedActive{
            color :#152bec;
          }
          .pointEdited{
            color:chartreuse;
          }
        }
      }
      .content{
        width: 100%;
        height: calc(100% - 200px);
        overflow: hidden;
      }
      .footer{
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        height: 200px;
        border-top: 1px solid #000000;
      }
    }
    .left{
      .footer{
        .nav{
          display: flex;
          align-items: center;
          margin-top: 10px;
          .bookList{
            .text{
              color: #152bec;
              margin-right: 20px;
            }
          }
          .btn{
            margin-left: 30px;
            border: 1px solid #000000;
            padding: 2px;
          }
        }
        .pagePanel{
          .pageList{
              display: flex;
              flex-wrap: wrap;
              max-height: 18vh;
              overflow: auto;
              .page{
                border: 1px solid #152bec;
                padding: 2px;
                margin: 10px 10px 0 0;
                font-size: 13px;
                color : #152bec;
              }
              .pageSelectedActive{
                color:#b30a18;
              }
          }
        }
      }
    }
    .right{
      .content{
        padding: 10px;
        box-sizing: border-box;
        .imageList{
          display: flex;
          flex-wrap: wrap;
          max-height: 100%;
          overflow: auto;
          .listItem{
            width: 100%;
            padding: 30px 0;
            border-bottom: 2px solid #b30a18;
            display: flex;
            .imgBox{
              width: 520px;
              border: 1px solid #000000;
              box-sizing: border-box;
              margin-right: 10px;
            }
            .btns{ 
              .btn{
                font-size: 13px;
                font-weight: 400;
                margin: 4px 2px;
                border: 1px solid #000000;
                padding: 5px;
              }
              .videoStateNo{
                font-weight: 200;
                font-size: 16px;
                color:#2726269d
              }
              .videoStateYes{
                font-weight: 500;
                font-size: 20px;
                color: hsla(54, 90%, 49%, 0.849)
              }
            }
          }
        }
        .videoBox{
          
        }
      }
      .footer{
        .tips{
          margin-top: 10px;
          display: flex;
          align-items: center;
          .text_tip_main{
            margin-right: 30px;
          }
        }
        .infos{
          .info{
            display: flex;
            .text_tip_sub{
              font-weight: 100;
              font-size: 14px;
              width: 80px;
              flex-shrink: 0;
            }
            .text_val_setting{
              flex: 1;
              font-size: 13px;
              font-weight: 500;
              .input{
                width: 100%;
              }
            }
          }
        }
        .btn{ 
          font-size: 13px;
          font-weight: 400;
          width: 30px;
          margin: 4px 2px;
          border: 1px solid #000000;
          padding: 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/eds/index.vue